import styles from "./Modal.module.sass";
import Icon from "../../../components/Icon";
import Empthy from "../../../components/Empty";
import { createPortal } from "react-dom";
import NFT from "./nft";

const ExperienceModal = ({ visible, onClose, data, refetch }) => {
	return createPortal(
		visible && (
			<div id="modal-NFT" className={styles.modal}>
				<div className={styles.control}></div>
				<div className={styles.outer}>
					{data ? (
						<>
							<button className={styles.close} onClick={onClose}>
								<Icon name="close" size="20" />
							</button>
							<NFT
								data={data}
								refresh={() => {
									onClose();
									refetch();
								}}
							/>
						</>
					) : (
						<>
							<button className={styles.close} onClick={onClose}>
								<Icon name="close" size="20" />
							</button>
							<Empthy title="Something went wrong" />
						</>
					)}
				</div>
			</div>
		),
		document.body
	);
};

export default ExperienceModal;
